import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const rolePermissionsNs = 'widgets';
export const rolePermissionsKeyPrefix = 'role_permissions';

export const useRolePermissionsTranslation = (): UseTranslationResponse<
  typeof rolePermissionsNs,
  typeof rolePermissionsKeyPrefix
  > => (
  useTranslation(rolePermissionsNs, { keyPrefix: rolePermissionsKeyPrefix })
);

export const ruRu = (__LOCALE_RU__ ? ({
  [rolePermissionsKeyPrefix]: {
    toast_success: 'Данные успешно обновлены',
    toast_error: 'Не удалось обновить данные',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [rolePermissionsKeyPrefix]: {
    toast_success: 'Data updated successfully',
    toast_error: 'Failed to update data',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [rolePermissionsKeyPrefix]: {
    toast_success: 'Datos actualizados correctamente',
    toast_error: 'Error al actualizar los datos',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [rolePermissionsKeyPrefix]: {
    toast_success: 'Dados atualizados com sucesso',
    toast_error: 'Falha ao atualizar os dados',
  },
}) : {}) as Record<string, unknown>;
